import { isMobileOrTablet } from "Utils/DeviceDetectHelpers";

export default store => ({
  path: "parent",
  onEnter: (nextState, replace) => {
    const queryString = nextState.location.search || "";

    // Get sub-path after /family
    const splat = nextState.params.splat || "";
    if (isMobileOrTablet()) {
      replace(`/app-download/parent/${splat}${queryString}`);
    } else {
      replace(`/${splat}${queryString}`);
    }
  },
});
